import { AppAreaConfig } from '@/funnels/@types'
import walkingMale from './activity-male-walking'
import walkingFemale from './activity-female-walking'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-walking',
	landing: {
		ids: ['loader-walking', 'age-walking'],
		route: {
			path: '/walking',
			name: 'main-walking-funnel',
		},
		overrides: [
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-main-walking', 'age-walking'],
			},
			{
				matcher: {
					$and: {
						utm_content: /walk/,
						utm_source: /google/,
						utm_campaign: /search/,
					},
				},
				ids: ['creatives-spreadsheet-walking', 'age-walking'],
			},
			{
				matcher: {
					lptype: 'main_loader', // /walking?safe&lptype=main_loader&lpid=
				},
				ids: ['dynamic-loader', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-walking-gender-selection',
		route: {
			path: '/walking/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'walking-survey',
		},
		slug: 'main-walking',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: walkingMale },
				female: { appArea: walkingFemale },
			},
		},
	},
}

export default appAreaConfig
